var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.742,
    height: 13.825,
    viewBox: "0 0 18.742 13.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15723",
    "data-name": "Group 15723",
    transform: "translate(-2172.189 -4446.323) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M34.415,138.124h0l-5.826-5.8a1.115,1.115,0,0,0-1.573,1.581l3.911,3.893H17.115a1.115,1.115,0,1,0,0,2.23H30.927l-3.911,3.892a1.115,1.115,0,0,0,1.573,1.581l5.826-5.8h0A1.116,1.116,0,0,0,34.415,138.124Z",
    transform: "translate(-2156.189 -4314.323) rotate(180)",
    fill: "#72d54a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderRightArrow);
export default __webpack_public_path__ + "static/media/slider-right-arrow.11673ee58747fd52ded62c8cc0f95e6c.svg";
export { ForwardRef as ReactComponent };